// Email address matcher.
const matcher = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

/**
 * Loosely validate an email address.
 *
 * @param {string} string
 * @return {boolean}
 */
export function isEmail(string) {
    if (string.length > 320) return false;
    return matcher.test(string);
}

export function getUtmParams(searchParams) {
    return {
        utm_source: searchParams.get("utm_source"),
        utm_medium: searchParams.get("utm_medium"),
        utm_campaign: searchParams.get("utm_campaign"),
        utm_content: searchParams.get("utm_content")
    };
}

export function isCrmActive() {
    return process.env.NEXT_PUBLIC_PROFILE && process.env.NEXT_PUBLIC_PROFILE !== "local";
}

export function isPostHogActive() {
    return process.env.NEXT_PUBLIC_PROFILE
}

export function isDealsEnabled() {
    return true
}

export function formatPrice(value, currency = 'USD', locale = 'en-US') {
    if (isNaN(value)) {
        console.warn('Invalid value provided for formatting.');
        return 'Invalid Price';
    }

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
}

export function formatDealTime(isoDate) {
    const date = new Date(isoDate);
    const now = new Date();
    const diffInHours = (date - now) / (1000 * 60 * 60);

    // Check if deal has expired
    if (diffInHours < 0) {
        return {
            text: "status",
            time: "Deal Expired"
        };
    }

    if (diffInHours < 24) {
        const hours = Math.floor(diffInHours);
        const minutes = Math.floor((diffInHours - hours) * 60);
        return {
            text: "ends soon in",
            time: `${hours}h ${minutes}m`
        };
    }

    return {
        text: "valid through",
        time: new Intl.DateTimeFormat('en-GB', {day: '2-digit', month: 'short', year: 'numeric'}).format(date)
    };
}

export function formatPriceRange(minPrice, maxPrice, discountedPrice, showVariant = true) {
    if (minPrice === maxPrice || !showVariant) {
        return formatPrice(discountedPrice);
    }
    return `${formatPrice(minPrice)}-${formatPrice(maxPrice)}`;
}

export const truncateString = function (str, noOfChar) {
    if (str.length > noOfChar) {
        return str.slice(0, noOfChar) + "...";
    }
    return str;
}
